import axios from "@/utils/request";

// 优惠券
export function backpack(data) {
  return axios.get(`/backpack`, {params: data});
}